import { useContext } from 'react';

import { RoleBuilderContext } from '../context/RoleBuilderProvider';

/** The New role wizard state and actions. Must be used under `RoleBuilderProvider`. */
export const useRoleBuilder = () => {
  const value = useContext(RoleBuilderContext);
  if (!value) throw new Error('useRoleBuilder must be used within <RoleBuilderProvider>');
  return value;
};
